import { discountCodes } from '../discountCode'
import { describeTable } from './describeTable'

describeTable(discountCodes, {
  description: `A discount code (alennuskoodi) redeemable in the public booking widget or applied by staff in the ERP. Two kinds of rows: campaign codes (reusable, max_redemptions NULL) and personal vouchers minted one per technician recommendation (visit_recommendations.discount_code_id, max_redemptions = 1, ~30-day validity).
Redemptions are not stored here: each use creates a negative visit_line_items row with discount_code_id = this id, so usage, attributed visits and revenue all come from joining visit_line_items → visits. The code string is unique only among live rows — a soft-deleted code can be re-created, so join by id, not by code.`,
  columns: {
    code: 'Uppercase code string the customer types.',
    discountType:
      'percent = value is a percentage of the booking; fixed = value is a GROSS euro amount (VAT included).',
    value: 'Percentage points for percent codes; gross euros for fixed codes.',
    validFrom: 'Start of validity; NULL = valid immediately.',
    validUntil:
      'End of validity (inclusive through its last day); NULL = never expires.',
    servicePreset:
      "Restricts the code to one booking-widget service (e.g. 'nuohous', 'ilmanvaihto_v2', 'ilp_huolto', 'sadevesikourut', 'iv_mittaus'); NULL = any service. Only enforced in public booking.",
    maxRedemptions:
      'Usage cap counted from live visit_line_items rows; NULL = unlimited; 1 = personal voucher.',
  },
})
